import axios from 'axios'

const fs = require('fs')

export default {
    state: {
        hearingInfo: [],
        lastFetched: null,
        intervalTimer: 300000,
        hearingLocation: {
            '01': 'Courtroom 1',
            '02': 'Courtroom 2',
            '03': 'Courtroom 3',
            '04': 'Courtroom 4',
            '05': 'Courtroom 5',
            '06': 'Courtroom 6',
            '07': 'Courtroom 7',
            '08': 'Courtroom 8',
            'Courtroom 1': 'Courtroom 1',
            'Courtroom 2': 'Courtroom 2',
            'Courtroom 3': 'Courtroom 3',
            'Courtroom 4': 'Courtroom 4',
            'Courtroom 5': 'Courtroom 5',
            'Courtroom 6': 'Courtroom 6',
            'Courtroom 7': 'Courtroom 7',
            'Courtroom 8': 'Courtroom 8',
            'Courtroom 9': 'Courtroom 9',
            'Courtroom 10': 'Courtroom 10',
            'Courtroom 11': 'Courtroom 11',
            'Courtroom 12': 'Courtroom 12',
            'Settlement Conference Room 3041': 'Settlement Conference Room 3041',
            'Settlement Conference Room 3500': 'Settlement Conference Room 3500',
            'RE': 'Remote',
            'C1': 'Room C1',
            'C3': 'Room C3',
        }
    },
    getters: {
        hearingInfo: state => state.hearingInfo,
        lastFetched: state => state.lastFetched,
        getHearingLocation: state => state.hearingLocation,
        intervalTimer: state => state.intervalTimer
    },
    mutations: {
        setHearingInfo(state, hearingObj) {
            //console.log('Hearing Obj', hearingObj)
            //state.hearingInfo.push(hearingObj)
            state.hearingInfo = hearingObj
        },
        emptyHearingInfo(state) {
            state.hearingInfo = []
        },
        setLastFetched(state, fetchObj) {
            state.lastFetched = fetchObj
        },
        setIntervalTimer(state, timer) {
            state.intervalTimer = timer
        }
    },
    actions: {
        verifyFile({ dispatch, getters, commit }) {
            var manualId = 0;
            const config = {
                method: 'post',
                url: 'https://us-central1-maryland-eb75e.cloudfunctions.net/apiV2/getHearingDetails/a763cd056f1b2405788443b7197e0708',
                params: { filename: getters.getKioskProfile.data().hearingFile + '.txt' }
            }

            axios(config)
                .then((response) => {
                    let hearingObj; let temp = []
                    if (getters.lastFetched === null) {
                        commit("setLastFetched", response.data.Header.Time)
                        response.data.Data.forEach(hearing => {
                            hearingObj = {
                                id: manualId++,
                                caseNumber: hearing.CaseNumber,
                                hearingTime: hearing.HearingTime,
                                partyName: hearing.PartyName.replace(/\//g, ' * '),
                            }
                            if (getters.getHearingLocation[hearing.HearingLocation] === undefined) {
                                hearingObj['hearingLocation'] = getters.getDefaultLocation
                            } else {
                                hearingObj['hearingLocation'] = getters.getHearingLocation[hearing.HearingLocation]
                            }
                            temp.push(hearingObj)
                            //commit('setHearingInfo', hearingObj)
                        })
                        commit('setHearingInfo', temp)
                    } else if (getters.lastFetched !== response.data.Header.Time) {
                        commit("setLastFetched", response.data.Header.Time)
                        response.data.Data.forEach(hearing => {
                            hearingObj = {
                                id: manualId++,
                                caseNumber: hearing.CaseNumber,
                                hearingTime: hearing.HearingTime + 'M',
                                partyName: hearing.PartyName.replace(/\//g, ','),
                            }
                            if (getters.getHearingLocation[hearing.HearingLocation] === undefined) {
                                hearingObj['hearingLocation'] = getters.getDefaultLocation
                            } else {
                                hearingObj['hearingLocation'] = getters.getHearingLocation[hearing.HearingLocation]
                            }
                            console.log('Hearing Obj: ', hearingObj)
                            temp.push(hearingObj)
                            //commit('setHearingInfo', hearingObj)
                        })
                        commit('setHearingInfo', temp)
                    } else {
                        console.log("Data is up to date", new Date())
                    }
                })
                .catch((error) => {
                    if (error.response.status === 404) {
                        console.log('File not present on FTP server')
                    } else if (error.response.status === 403) {
                        console.log('Access problem to FTP Server')
                    }
                });
        },
        filePullScheduler({ dispatch, getters }) {
            const currentDate = new Date()
            const hour = currentDate.getHours()
            // 7 AM to 6 PM 
            console.log('Current time', hour)
            if (hour >= 7 && hour < 17) {
                dispatch('verifyFile')
                setTimeout(() => { dispatch('filePullScheduler') }, 300000)
            } else if (hour >= 18) {
                dispatch('verifyFile')
                setTimeout(() => {
                    dispatch('filePullScheduler')
                }, 3600000)
            } else {
                dispatch('verifyFile')
                setTimeout(() => {
                    dispatch('filePullScheduler')
                }, 3600000)
            }
        }
    }
}
